import { HREmployeeDetails } from './hremployeecommunicationdetails.model';
import { PeopleManagersHistoryDetails } from './PeopleManagersHistoryDetails';
import { FileToUpload } from './filetoupload';
import { ProfileImageUpload } from './ProfileImageUpload';
import { ProfileVerificationStatus } from './ProfileVerificationStatus';
import { SeniorManagersHistoryDetails } from './SeniorManagersHistoryDetails';
import { EmployeeLocationHistories } from './EmployeeLocationHistories';
import { EmployeeDesignationHistories } from './EmployeeDesignationHistories';
import { EmployeeDepartmentHistories } from './EmployeeDepartmentHistories';
import { EmployeeCadreHistories } from './EmployeeCadreHistories';
import { EmployeeEmailHistories } from './EmployeeEmailHistories';


export class BasicEmployeeDetails {
  EmpCode: number;
  Email: string;
  DOJ: Date;
  DesignationId: number;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Gender: string;
  DOB: Date;
  Age: number;
  CelebratedDOB: Date;
  NamePerRecords: string;
  BloodGroup: string;
  MobileNo: string;
  LocationID: number;
  EmpType: string;
  PeopleManagerCode: number;
  SeniorManagerCode: number;
  DepartmentId: number;
  Department: string;
  CadreId: number;
  Cadre: string;
  RoleID: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  SecondaryEmail: string;
  DateOfExit: Date;
  MCPId: string;
  TimeZone: string;
  TeamId: number;
  EeTypeId: number;
  ExpertiseId: string;
  TechGroupId: number;
  DivisionId: number;
  Title: string;
  ProfileFileName: string;
  ProfileFilePath: string;
  ProfileFile: ProfileImageUpload;
  employeeDetails: HREmployeeDetails = new HREmployeeDetails();
  profileVerification: ProfileVerificationStatus = new ProfileVerificationStatus();
  ConsultantType: string;
  //peopleManagersHistoryDetails: PeopleManagersHistoryDetails[] = [];
  peopleManagersHistoryDetails: PeopleManagersHistoryDetails[] = [];
  seniorManagersHistoryDetails: SeniorManagersHistoryDetails[] = [];
  HistoryDetails: HistoryDetails[] = [];
  twoTabProfile: boolean;
  WhatsAppNumber: string;
  HiringType: string;
  FiveCStatus: string;
  EmpSubType: string;
  EmpStatus: string;
  JobLocationState: string;
  IsMigratedOnH1: boolean;
  US_DOJ: Date;
  US_DOE: Date;
  OldIndLocationID: number;
  WorkPlace: string;
  Billability: boolean;
  CostCenter: string;
  Duplicates: boolean;
  GMCInclusion: Date;
  GPAInclusion: Date;
  IsDeceased: boolean;
  JoiningBonus: any;
  LinkedInID: string;
  ResumeDocumentPath: string;
  ResumeDocumentName: string;
  ResumeFile: FileToUpload;
  ResignationDate: Date;
  Aadhar: string;
  PAN: string;
  Type: string;
  GroupId: string;
  TechGroupName: string;
  ActualFirstName: string;
  StreamId: string;
  PrimarySkillId: string;
  employeeAdditionalSkills: EmployeeAdditionalSkills[];
  isFromProfile: boolean;
  ResumeLastUpdated: string;
  ProbationDate:Date
}

export class EmpHistoryDetails {
  historyDetails: HistoryDetails;

}

export class EmployeeAdditionalSkills {
  Id: number;
  EmpCode: number;
  TechGroupId: number;
  SkillId: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}

export class HistoryDetails {
  peopleManagersHistoryDetails: PeopleManagersHistoryDetails[] = [];
  seniorManagersHistoryDetails: SeniorManagersHistoryDetails[] = [];
  employeeLocationHistories: EmployeeLocationHistories[] = [];
  employeeDesignationHistories: EmployeeDesignationHistories[] = [];
  employeeDepartmentHistories: EmployeeDepartmentHistories[] = [];
  employeeCadreHistories: EmployeeCadreHistories[] = [];
  employeeEmailHistories: EmployeeEmailHistories[] = [];
  hasErrorss: boolean;
  EmpCode: number;
  ExitInterviewHRComments: string;
}
